import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const ClientPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default ClientPage